import { Treatment, TreatmentInfo } from '../../types/Diagnose.type';
import { RequestAction } from '../../types/request.action.type';
import { SubsequentDiagnose } from '../diagnosesPage/diagnoses.page.state';

export type TreatmentsPageState = {
  dirty: boolean;
  isLoading: boolean;
  error?: string;
  externalSaveAndContinue: boolean;
  treatmentInfos?: TreatmentInfo[];
  treatmentsObj: { [x: number]: number };
  subsequentTreatmentInfos?: TreatmentInfo[];
  subsequentTreatmentsObj: { [x: number]: number };
  selectedTreatments: number[];
  selectedTreatmentsObj: { [x: number]: Treatment };
  subsequentDiseaseNames: { [x: number]: string };
  subsequentDiseaseIds: number[];
  selectedSubsequentDiseases: number[];
  confirmedSubsequentDiseases: number[];
};

export const TreatmentsPageDefault: TreatmentsPageState = {
  dirty: false,
  isLoading: false,
  externalSaveAndContinue: false,
  treatmentsObj: {},
  subsequentTreatmentsObj: {},
  selectedTreatments: [],
  selectedTreatmentsObj: {},
  subsequentDiseaseNames: {},
  subsequentDiseaseIds: [],
  selectedSubsequentDiseases: [],
  confirmedSubsequentDiseases: [],
  subsequentTreatmentInfos: [],
};

export type TreatmentsPageAction =
  | RequestAction<TreatmentInfo[]>
  | {
      type: 'import';
      treatmentsPage: TreatmentsPageState;
    }
  | {
      type: 'setExternalSaveAndContinue';
      value: boolean;
    }
  | {
      type: 'setTreatmentSelected';
      checked: boolean;
      treatment: Treatment;
    }
  | {
      type: 'deselectTreatments';
      deselectTreatmentIds: number[];
    }
  | {
      type: 'setSubsequentDiseaseSelected';
      checked: boolean;
      diseaseId: number;
    }
  | {
      type: 'setSubsequentDiseaseConfirmed';
      checked: boolean;
      diseaseId: number;
    }
  | {
      type: 'setSubsequentDiseaseNames';
      subsequentDiagnosesObj: {
        [x: number]: SubsequentDiagnose[];
      };
    }
  | {
      type: 'resetSubSequentDiseases';
    }
  | {
      type: 'setDirty';
      dirty: boolean;
    };
